import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import CarbonStory from "./components/CarbonStory";
import Story from "./components/Story";
import Sectors from "./components/Sectors";
import VideoShowcase from "./components/VideoShowcase";
import Team from "./components/Team";
import Quote from "./components/Quote";
import LeadForm from "./components/LeadForm";
import Footer from "./components/Footer";
import LegalPage from "./pages/LegalPage";

const Landing = () => {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    return () => clearTimeout(t);
  }, []);
  return (
  <div className="bg-1 min-h-screen">
    <Navbar />
    <Hero />
    <About />
    <CarbonStory />
    <Story />
    <VideoShowcase />
    <Sectors />
    <Team />
    <Quote />
    <LeadForm />
    <Footer />
  </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/:slug" element={<LegalPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
